import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    position: absolute;
    top: var(--wm-top, 16px);
    left: var(--wm-left, 16px);
    width: 10%;
    max-width: 96px;
    opacity: 0.6;
    pointer-events: none;
    user-select: none;
    z-index: 10;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;
